'use client';

import { useEffect, useState } from 'react';
import { cn } from '@/app_lib/utils/utils';

type TocItem = {
  id: string;
  text: string;
};

export const TableOfContents = ({ headings, className }: { headings: TocItem[]; className?: string }) => {
  const [activeId, setActiveId] = useState<string | null>(null);

  useEffect(() => {
    const headingElements = Array.from(document.querySelectorAll('.wp-block-heading')).filter((h) =>
      h.textContent?.trim(),
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveId(entry.target.id);
          }
        });
      },
      {
        // this root margin doesn't really make sense to me. 200px makes no sense but its the exact value I need somehow so, sure
        rootMargin: '200px 0px -80% 0px',
        threshold: 0.1,
      },
    );

    headingElements.forEach((h) => observer.observe(h));

    return () => observer.disconnect();
  }, []);

  // Allows us to scroll to the heading while taking into account the header and disclaimer, etc
  const scrollToHeading = (id: string) => {
    const el = document.getElementById(id);
    if (!el) {
      return;
    }

    const y = el.getBoundingClientRect().top + window.pageYOffset - 100;

    window.scrollTo({ behavior: 'smooth', top: y });
  };

  return (
    <ul className={className}>
      {headings.map((item) => (
        <li key={item.id}>
          <button
            className={cn(
              'typography-default flex w-full p-2 font-semibold hover:text-accent hover:bg-accent-inverse text-left cursor-pointer',
              item.id === activeId && 'bg-accent-inverse text-accent',
            )}
            onClick={() => scrollToHeading(item.id)}
            type='button'
          >
            {item.text}
          </button>
        </li>
      ))}
    </ul>
  );
};
